import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { ICarePlansModel } from './types';

const carePlans: ICarePlansModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default carePlans;
